<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.42908 14.7827C6.0521 14.7827 5.80078 14.5314 5.80078 14.1544V2.84509C5.80078 2.46812 6.0521 2.2168 6.42908 2.2168C6.80606 2.2168 7.05737 2.46812 7.05737 2.84509V14.1544C7.05737 14.5314 6.80606 14.7827 6.42908 14.7827Z"
      fill="#8C8C8C"
    />
    <path
      d="M2.65955 7.24317C2.47106 7.24317 2.3454 7.18034 2.21974 7.05468C1.96842 6.80336 1.96842 6.42638 2.21974 6.17506L5.98952 2.40529C6.24084 2.15397 6.61781 2.15397 6.86913 2.40529C7.12045 2.6566 7.12045 3.03358 6.86913 3.2849L3.09935 7.05468C2.97369 7.18034 2.84804 7.24317 2.65955 7.24317Z"
      fill="#8C8C8C"
    />
    <path
      d="M9.57068 14.7827C9.1937 14.7827 8.94238 14.5314 8.94238 14.1544V2.84509C8.94238 2.46812 9.1937 2.2168 9.57068 2.2168C9.94766 2.2168 10.199 2.46812 10.199 2.84509V14.1544C10.199 14.5314 9.94766 14.7827 9.57068 14.7827Z"
      fill="#8C8C8C"
    />
    <path
      d="M9.57068 14.7827C9.38219 14.7827 9.25653 14.7199 9.13087 14.5942C8.87955 14.3429 8.87955 13.9659 9.13087 13.7146L12.9006 9.94484C13.152 9.69352 13.5289 9.69352 13.7803 9.94484C14.0316 10.1962 14.0316 10.5731 13.7803 10.8245L10.0105 14.5942C9.88483 14.7827 9.75917 14.7827 9.57068 14.7827Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
